export enum IndividualRoleKind {
  OWNER = "owner",
  OFFICER = "officer",
  DIRECTOR = "director",
  GOVERNOR = "governor",
  MEMBER = "member",
  MANAGER = "manager",
  QUALIFIER = "qualifier",
  OTHER_LICENCE_PERSONNEL = "other_licence_personnel",
}

export const dataByIndividualRoleKind: Record<
  IndividualRoleKind,
  { label: string }
> = {
  [IndividualRoleKind.OWNER]: { label: "Owner" },
  [IndividualRoleKind.OFFICER]: { label: "Officer" },
  [IndividualRoleKind.DIRECTOR]: { label: "Director" },
  [IndividualRoleKind.GOVERNOR]: { label: "Governor" },
  [IndividualRoleKind.MEMBER]: { label: "Member" },
  [IndividualRoleKind.MANAGER]: { label: "Manager" },
  [IndividualRoleKind.QUALIFIER]: { label: "Qualifier" },
  [IndividualRoleKind.OTHER_LICENCE_PERSONNEL]: {
    label: "Licence personnel",
  },
}
